import {Injectable} from "@angular/core";
import {Product} from "@app/core/product/domain/dtos/product";
import {Observable} from "rxjs";
import {PdfCatalogRepo} from "@app/core/pdf-catalog/domain/repositories/pdf-catalog.repo";

/**
 * Use case for retrieving the products the user has added for the PDF catalog.
 */
@Injectable({
    providedIn: "root",
})

export class GetPdfCatalogProductsUseCase {

    constructor(private pdfCatalogLocal: PdfCatalogRepo) {
    }


    execute(): Observable<Product[]> {
        return this.pdfCatalogLocal.getProducts();
    }
}
